import { Link } from 'react-router-dom';

interface Stage {
  icon: string;
  title: string;
  desc: string;
  to?: string;
  linkLabel?: string;
}

const stages: Stage[] = [
  {
    icon: 'ri-user-add-line',
    title: 'Новые сотрудники',
    desc: 'Адаптация, освоение стандартов и выход на самостоятельную работу. Чем быстрее новичок начнёт работать самостоятельно, тем меньше нагрузка на руководителя.',
    to: '/enciklopediya-korporativnogo-obucheniya/adaptaciya-sotrudnikov',
    linkLabel: 'Адаптация сотрудников',
  },
  {
    icon: 'ri-user-line',
    title: 'Действующие специалисты',
    desc: 'Развитие профессиональных и гибких компетенций, чтобы сотрудники работали эффективнее и осваивали новые инструменты.',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Сильные сотрудники',
    desc: 'Расширение ответственности, развитие экспертизы и подготовка к более сложным задачам, чтобы компания не зависела от отдельных людей.',
  },
  {
    icon: 'ri-vip-crown-line',
    title: 'Потенциальные руководители',
    desc: 'Подготовка к управленческой роли и кадровому резерву: развитие навыков постановки задач, делегирования и обратной связи.',
    to: '/menedzhment-i-liderstvo',
    linkLabel: 'Менеджмент и лидерство',
  },
  {
    icon: 'ri-user-settings-line',
    title: 'Руководители',
    desc: 'Развитие управленческих компетенций и лидерства, чтобы руководители управляли командой, а не выполняли работу за сотрудников.',
    to: '/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley',
    linkLabel: 'Тренинг для руководителей',
  },
];

export default function CareerStages() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Развитие персонала должно учитывать роль сотрудника
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          На каждом этапе карьеры сотруднику нужны разные компетенции, поэтому подход к развитию должен отличаться.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {stages.map((s, i) => (
            <div key={i} className="bg-gray-50 rounded-xl border border-gray-100 p-5 md:p-6 hover:border-teal-200 transition-colors group flex flex-col">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-200 transition-colors">
                <i className={`${s.icon} text-xl text-teal-700`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{s.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-4 flex-grow">{s.desc}</p>
              {s.to ? (
                <Link to={s.to} className="inline-flex items-center gap-1.5 text-sm font-semibold text-teal-600 hover:text-teal-700 transition-colors cursor-pointer mt-auto">
                  {s.linkLabel}
                  <i className="ri-arrow-right-line"></i>
                </Link>
              ) : (
                <span className="text-sm text-gray-400 mt-auto">В рамках комплексной программы</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}